import { Component, Input, OnInit, HostListener, input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-application-history',
    templateUrl: './application-history.component.html',
    styleUrl: './application-history.component.scss',
    imports: [DatePipe]
})
export class ApplicationHistoryComponent implements OnInit {
	@Input() application: any;
	readonly settings = input<any>();

	public isJobTitleView: boolean;
	public isLocationView: boolean;
	public isDateView: boolean;
	public isStatusView: boolean;

	private screenWidth: number;
	public mobile = false;
	private readonly forMobileSize = 1200;

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.mobile = this.screenWidth <= this.forMobileSize;

		const settings = this.settings();
  this.isJobTitleView = settings
			?.filter((e: any) => e.name == 'Job Title')
			.map((e: any) => e.active)[0];
		this.isLocationView = settings
			?.filter((e: any) => e.name == 'Location')
			.map((e: any) => e.active)[0];
		this.isDateView = settings
			?.filter((e: any) => e.name == 'Date')
			.map((e: any) => e.active)[0];
		this.isStatusView = settings
			?.filter((e: any) => e.name == 'Status')
			.map((e: any) => e.active)[0];
	}

	@HostListener('window:resize')
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		this.mobile = this.screenWidth <= this.forMobileSize;
	}
}
